import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ZipCodes } from 'src/app/features-common/constants/ZipCodes';
import { ConfigValuesService } from 'src/app/features-common/services/config-values.service';
import { RetailerService } from '../../../retailers/retailer.service';
import { ConsumersService } from '../../consumers.service';

@Component({
  selector: 'app-edit-consumer',
  templateUrl: './edit-consumer.component.html',
  styleUrls: ['./edit-consumer.component.scss']
})
export class EditConsumerComponent extends FeaturesBaseComponent implements OnInit {
  editConsumerForm: FormGroup;
  phone: (string | RegExp)[];
  usStateZips = ZipCodes.USAStatesShort;
  status: string[] = ['Active', 'InActive', 'Hold']
  emailPattern: RegExp;
  phonePattern: RegExp;
  phoneRegx = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  consumerDetails: any;
  userId: any;
  loyaltyPt:any;
  showErrorMsg:boolean=false;
  errMsg:any="";
  thresholdLoyaltyPt: any;
  
  constructor(private activeRoute: ActivatedRoute,private router: Router,private uiConfigService: ConfigValuesService, private dialog : MatDialog, private consumersService: ConsumersService) {
    super();
    this.phone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    this.emailPattern =  /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
    this.phonePattern = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
    this.userId =this.activeRoute.snapshot.params.userId;
    this.editConsumerForm = new FormGroup({
      firstName: new FormControl('',[]),
      lastName: new FormControl('',[]),
      emailId: new FormControl('',[Validators.required]),
      mobileNumber: new FormControl('',[Validators.required]),
      userStatus: new FormControl('',[Validators.required]),
      totalLoyaltyPoints: new FormControl('',[Validators.required]),
      // enrollTilaRewardsStatus: new FormControl('',[Validators.required]),
      enrollPromotionalText: new FormControl('',[Validators.required]),
      enrollPromotionalEmail: new FormControl('',[Validators.required])
    })
    this.uiConfigService.getUIConfigValues('LoyalityPointsLimit').subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.thresholdLoyaltyPt = resData[0];
      }
    })
    this.initForm();

  }
  charMask(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9| ]+$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }
    return nameMask;
  }


  ngOnInit(): void {
    super.ngOnInit()
  }


  initForm() {
  
    this.consumersService.getConsumerbyId(this.userId).subscribe(
      res => {
        let data: any = res;
        
        this.consumerDetails = data.data;
        this.editConsumerForm.get('firstName').setValue(this.consumerDetails.firstName),
        this.editConsumerForm.get('lastName').setValue(this.consumerDetails.lastName),
        this.editConsumerForm.get('emailId').setValue(this.consumerDetails.emailId),
        this.editConsumerForm.get('mobileNumber').setValue(this.consumerDetails.mobileNumber),
        this.editConsumerForm.get('userStatus').setValue(this.consumerDetails.userStatus),
        this.editConsumerForm.get('totalLoyaltyPoints').setValue(this.consumerDetails.totalLoyaltyPoints),
        // this.editConsumerForm.get('enrollTilaRewardsStatus').setValue((this.consumerDetails.enrollTilaRewardsStatus == 'Yes')),
        this.editConsumerForm.get('enrollPromotionalText').setValue((this.consumerDetails.enrollPromotionalText == 'Yes')),
        this.editConsumerForm.get('enrollPromotionalEmail').setValue((this.consumerDetails.enrollPromotionalEmail  == 'Yes'))

      })
  }
  onChangeLoyaltyPt($event){
    let defaultLoyaltyPt:any = this.consumerDetails.totalLoyaltyPoints;
    let lp:any=this.loyaltyPt;
    if(this.thresholdLoyaltyPt < lp - defaultLoyaltyPt ){
      this.showErrorMsg=true;
      this.errMsg="You have reached the maximum limit for adding loyalty points."
    }else if(-this.thresholdLoyaltyPt>  lp - defaultLoyaltyPt){
      this.showErrorMsg=true;
      this.errMsg="You have reached the maximum limit for removing loyalty points."
    }else{
      this.showErrorMsg=false;
      this.errMsg=""
    }
  }
  get f() {
    return this.editConsumerForm.controls;
  }

  editConsumerSubmit($event) {
    
    if (!this.editConsumerForm.valid) {
      return
    }
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.editConsumerForm)
        }
      });

  }
  setSubmitParameters(editConsumerForm: FormGroup) {
    let formData = {
      "userId" : this.userId,
      "firstName": editConsumerForm.get('firstName').value,
      "lastName": editConsumerForm.get('lastName').value,
      "emailId": editConsumerForm.get('emailId').value,
      "mobileNumber": editConsumerForm.get('mobileNumber').value,
      "userStatus": editConsumerForm.get('userStatus').value,
      "totalLoyaltyPoints": editConsumerForm.get('totalLoyaltyPoints').value,
      "enrollPromotionalText": editConsumerForm.get('enrollPromotionalText').value ? 'Yes' : 'No',
      "enrollTilaRewardsStatus":  'Yes' ,
      "enrollPromotionalEmail": editConsumerForm.get('enrollPromotionalEmail').value? 'Yes' : 'No',
    }
    
    this.consumersService.updateConsumer(formData).subscribe(
      res => {
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_111") || res.responseStatus == 'Success'){
          //alert("test");
          this.toastrService.success('Consumer updated successfully!', 'Success', {
            timeOut: 3000,
          })
          //alert("test2");
         
          this.router.navigateByUrl('features/consumers/all-consumers')
        }
      }
    )
  }
  onCancel() {
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      } 
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigateByUrl('features/consumers/all-consumers')
    return
      }
    });


  }
  

  ngOnDestroy() {
    super.ngOnDestroy()
  }

  checkSubmitDisplayed() {
    return !(this.editConsumerForm.valid && !this.editConsumerForm.pristine && !this.showErrorMsg ); 
  }


  onToggleChanges() {
    
    if (
  this.editConsumerForm.get('enrollPromotionalText').value === false &&
  this.editConsumerForm.get('enrollPromotionalEmail').value === false
) {
  this.editConsumerForm.get('enrollPromotionalText').setValue(true);
}
  }

}
